export const SET_CLIENT = "CLIENTS/SET_CLIENT"
export const SET_CLIENT_LOGGED = "CLIENTS/SET_CLIENT_LOGGED"
export const SET_EMAIL_REGISTER = "CLIENTS/SET_EMAIL_REGISTER"
export const SET_LIST_EMPLOYEE_TYPES = "CLIENTS/SET_LIST_EMPLOYEE_TYPES"